<div class="banner justify-content-center" role="banner">
  <h1 class="text-white">{{ 'badges.page.title' | translate }}</h1>
</div>

<fgb-challenges-nav></fgb-challenges-nav>

<div class="container mt-4">
  <fgbcl-badge-overview-list [showPlaceholder]="true"></fgbcl-badge-overview-list>
</div>
